import feathersClient, { makeServicePlugin, BaseModel } from '../../feathers-client'

class FrameworksTranslations extends BaseModel {
  // Required for $FeathersVuex plugin to work after production transpile.

  static modelName = 'FrameworkTranslation'
  // Define default properties here
  static instanceDefaults () {
    return {
      frameworkId: null,
      title: '',
      localeId: null,
    }
  }
}
const servicePath = 'frameworks-translations'
const servicePlugin = makeServicePlugin({
  Model: FrameworksTranslations,
  service: feathersClient.service(servicePath),
  servicePath,
})

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
  before: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
})

export default servicePlugin
